import {Image} from "@/entities/Image";

export default class Evento {
  constructor(obj, imgBasePath) {
    this.id = obj.id;
    this.expiration = new Date(obj.expiration);
    this.start = new Date(obj.start);
    this.name = obj.name;
    this.img = new Image(obj.img, imgBasePath);
  }
}